import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PictureAppDisabled = ({ ...other }) => {
  const theme = useTheme();
  const { main, lighter, secondary, secondaryLight } = theme.palette.comete;

  return (
    <Box {...other}>
      <svg width="257" height="256" viewBox="0 0 257 256" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.6255 72.0801C34.1888 72.0801 30.5921 75.6768 30.5921 80.1136C30.5921 84.5503 34.1888 88.147 38.6255 88.147H142.056C146.493 88.147 150.09 84.5503 150.09 80.1136C150.09 75.6768 146.493 72.0801 142.056 72.0801H38.6255ZM236.45 192.582C243.105 192.582 248.5 187.187 248.5 180.532C248.5 173.877 243.105 168.482 236.45 168.482C229.795 168.482 224.4 173.877 224.4 180.532C224.4 187.187 229.795 192.582 236.45 192.582ZM166.157 80.1136C166.157 75.6768 169.754 72.0801 174.19 72.0801H190.257C194.694 72.0801 198.291 75.6768 198.291 80.1136C198.291 84.5503 194.694 88.147 190.257 88.147H174.19C169.754 88.147 166.157 84.5503 166.157 80.1136ZM34.6088 100.197C20.1893 100.197 8.5 111.887 8.5 126.306C8.5 140.305 19.5173 151.731 33.3541 152.385C35.853 153.747 37.5486 156.397 37.5486 159.444C37.5486 163.88 33.9519 167.477 29.5151 167.477H198.462C194.025 167.477 190.429 163.88 190.429 159.444C190.429 156.393 192.129 153.74 194.633 152.38C208.419 151.671 219.379 140.268 219.379 126.306C219.379 111.887 207.689 100.197 193.27 100.197H34.6088ZM16.5335 180.03C16.5335 173.097 22.1533 167.478 29.0858 167.478H196.785C203.717 167.478 209.337 173.097 209.337 180.03C209.337 186.962 203.717 192.582 196.785 192.582H29.0858C22.1533 192.582 16.5335 186.962 16.5335 180.03Z"
          fill={lighter}
        />
        <path
          d="M156.477 102.773L38.3745 54.2549L89.7236 172.43C98.2817 191.837 117.11 203.967 137.992 203.62C166.747 203.273 189.341 179.361 188.998 150.251C188.656 129.457 175.99 110.743 156.477 102.773Z"
          fill={main}
        />
        <mask
          id="mask0_365_2340"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="48"
          y="64"
          width="136"
          height="135"
        >
          <path
            d="M154.709 107.923L48.4162 64.2979L94.6303 170.556C102.333 188.006 119.278 198.913 138.072 198.601C163.951 198.289 184.286 176.788 183.978 150.613C183.669 131.917 172.27 115.09 154.709 107.923Z"
            fill={main}
          />
        </mask>
        <g mask="url(#mask0_365_2340)">
          <rect x="109.922" y="130.825" width="61.5063" height="70.2929" rx="5" fill="url(#paint1_radial_365_2340)" />
        </g>
        <mask
          id="mask1_365_2340"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="118"
          y="111"
          width="45"
          height="14"
        >
          <rect x="118.709" y="111.995" width="43.9331" height="12.5523" fill="url(#paint2_radial_365_2340)" />
        </mask>
        <g mask="url(#mask1_365_2340)">
          <rect x="118.709" y="111.995" width="43.9331" height="31.3808" rx="5" fill="url(#paint3_radial_365_2340)" />
        </g>
        <path
          d="M128.5 157.434C123.981 157.434 121.973 154.422 121.973 154.422C121.973 154.422 124.985 156.43 128.5 156.43C132.015 156.43 135.027 154.422 135.027 154.422C135.027 154.422 133.019 157.434 128.5 157.434Z"
          fill={main}
          stroke={main}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.6 157.434C148.082 157.434 146.073 154.422 146.073 154.422C146.073 154.422 149.086 156.43 152.6 156.43C156.115 156.43 159.128 154.422 159.128 154.422C159.128 154.422 157.119 157.434 152.6 157.434Z"
          fill={main}
          stroke={main}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.561 167.978C142.561 168.313 142.357 168.678 141.901 168.982C141.449 169.284 140.795 169.486 140.048 169.486C139.301 169.486 138.648 169.284 138.195 168.982C137.74 168.678 137.536 168.313 137.536 167.978C137.536 167.643 137.74 167.278 138.195 166.974C138.648 166.672 139.301 166.47 140.048 166.47C140.795 166.47 141.449 166.672 141.901 166.974C142.357 167.278 142.561 167.643 142.561 167.978Z"
          fill={main}
          stroke={main}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M201.303 68.0669C201.303 68.6192 201.751 69.0669 202.303 69.0669H212.973C213.526 69.0669 213.973 68.6192 213.973 68.0669V67.2662C213.973 66.7139 213.526 66.2662 212.973 66.2662H208.171C207.271 66.2662 206.829 65.1703 207.477 64.546L217.064 55.3112C217.26 55.1227 217.37 54.8627 217.37 54.591V54C217.37 53.4477 216.923 53 216.37 53H205.7C205.148 53 204.7 53.4477 204.7 54V54.8007C204.7 55.353 205.148 55.8007 205.7 55.8007H210.496C211.396 55.8007 211.838 56.8963 211.19 57.5207L201.609 66.7558C201.414 66.9443 201.303 67.2042 201.303 67.4757V68.0669ZM165.153 88.1504C165.153 88.7027 165.6 89.1504 166.153 89.1504H183.158C183.71 89.1504 184.158 88.7027 184.158 88.1504V85.9493C184.158 85.397 183.71 84.9493 183.158 84.9493H174.214C173.314 84.9493 172.872 83.8534 173.52 83.2291L188.947 68.3693C189.143 68.1808 189.253 67.9208 189.253 67.6491V66.05C189.253 65.4977 188.805 65.05 188.253 65.05H171.248C170.696 65.05 170.248 65.4977 170.248 66.05V68.2511C170.248 68.8034 170.696 69.2511 171.248 69.2511H180.181C181.081 69.2511 181.523 70.3466 180.875 70.9711L165.459 85.8311C165.263 86.0196 165.153 86.2795 165.153 86.5511V88.1504Z"
          fill={secondary}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.7918 59.4713C70.7918 60.827 69.6461 61.9259 68.2328 61.9259C66.8194 61.9259 65.6737 60.827 65.6737 59.4713C65.6737 58.1156 66.8194 57.0166 68.2328 57.0166C69.6461 57.0166 70.7918 58.1156 70.7918 59.4713ZM47.7604 142.93C47.7604 144.286 46.6147 145.385 45.2014 145.385C43.7881 145.385 42.6423 144.286 42.6423 142.93C42.6423 141.575 43.7881 140.476 45.2014 140.476C46.6147 140.476 47.7604 141.575 47.7604 142.93ZM196.185 129.429C199.012 129.429 201.303 127.231 201.303 124.52C201.303 121.808 199.012 119.61 196.185 119.61C193.359 119.61 191.067 121.808 191.067 124.52C191.067 127.231 193.359 129.429 196.185 129.429Z"
          fill={secondary}
        />
        <defs>
          <radialGradient
            id="paint0_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(72.8932 83.1263) rotate(50.3815) scale(123.029 124.178)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
          <radialGradient
            id="paint1_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(121.028 140.679) rotate(54.3356) scale(61.0492 59.4222)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
          <radialGradient
            id="paint2_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(126.642 113.755) rotate(19.2067) scale(26.9228 17.1867)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
          <radialGradient
            id="paint3_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(126.642 116.394) rotate(41.0533) scale(33.7147 34.311)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
          <radialGradient
            id="paint4_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(174.581 58.0678) rotate(40.1684) scale(39.5451 40.053)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
          <radialGradient
            id="paint5_radial_365_2340"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(71.2895 69.4047) rotate(34.1804) scale(110.988 105.995)"
          >
            <stop stopColor={secondary} />
            <stop offset="1" stopColor={secondaryLight} />
          </radialGradient>
        </defs>
      </svg>
    </Box>
  );
};

export default PictureAppDisabled;
